mutation DeletePolls($ids: [ID!]!) {
  deletePolls(ids: $ids) {
    id
  }
}
